import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { removeItem, addQuantity, subtractQuantity, selectMainCategory } from './reducers/cartReducer'
import Navbar from './Navbar'
import Recipe from './Recipe'
import swal from 'sweetalert';
var tot = 0
var taxrate = 0.0915
class Cart extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    //to remove the item completely
    handleRemove = (id, index) => {

        // this.props.subtractQuantity(id+"_"+index);
        this.props.removeItem(id + "_" + "index-" + index);
        console.log(this.props.orders)
        this.forceUpdate();


    }
    //to add the quantity
    handleAddQuantity = (id, index) => {

        this.props.addQuantity(id + "_" + index);
    }
    //to substruct from the quantity
    handleSubtractQuantity = (id, index) => {
        this.props.subtractQuantity(id + "_" + index);


    }
    handleClick = (mainCategory) => {

        if (mainCategory) {
            this.props.selectMainCategory(mainCategory);
            this.props.history.push("/home")

        }

    }


    render() {
        tot = 0;

        if (this.props.orders.length > 0) {
            tot = parseFloat(this.props.total)
            var totTax = parseFloat((tot * taxrate)).toFixed(2)

            var totalWithTax = (parseFloat(tot) + parseFloat(totTax)).toFixed(2);

        }

        let addedItems = this.props.orders.length ?
            (
                this.props.orders.map((item, index) => {
                    // if (item.category==="Base")
                    // {  


                    var toppingList = item.topping;
                    // if (toppingList.length>2)
                    //     tot=tot+0.5*parseInt(item[2])*(toppingList.length-2)

                    return (
                        <li style={{ paddingLeft: "1" }} className="collection-item avatar" key={item.id}>


                            <div className="item-desc">
                                <span className="title">{item.title} - {item.mainCategory}</span>

                                <p><b>${item.price}</b></p>
                                <p>
                                    <b>Quantity: {item.quantity}</b>
                                </p>
                                {toppingList != "" ?
                                    <p>
                                        <b>{toppingList.map((to, index) => <span key={`demo_snap_${index}`}>{(index ? ', ' : '') + to.title}&nbsp;</span>)} </b>
                                    </p> : ""
                                }
                                <div className="add-remove">

                                    <Link to="/cart"><i className="material-icons" onClick={() => { this.handleAddQuantity(item.id, index) }}>arrow_drop_up</i></Link>
                                    <Link to="/cart"><i className="material-icons" onClick={() => { this.handleSubtractQuantity(item.id, index) }}>arrow_drop_down</i></Link>
                                </div>
                                <button className="waves-effect waves-light btn red remove" onClick={() => { this.handleRemove(item.id, index) }}>Remove</button>
                            </div>
                        </li>
                    )
                    // }

                })
            ) :

            (
                <p>Nothing.</p>
            )

        return (
            <div>
                <Navbar isAuthed={true} />
                <div className="container">
                    <div className="cart"><br />
                        <h5>You have ordered:</h5>
                        <ul className="collection cartUl ">
                            {addedItems}

                            <li class="totalList">
                                <span className="title">Sub Total: ${parseFloat(tot).toFixed(2)}</span>&nbsp;&nbsp;&nbsp;
                    <span>Tax: ${parseFloat((tot * taxrate)).toFixed(2)}</span>&nbsp;&nbsp;
                    <span><b>Total: ${totalWithTax}</b></span>
                            </li>
                        </ul>
                        <Link className="waves-effect waves-light btn " to={{
                            pathname: '/',
                            state: {
                                flag: true
                            }
                        }}>Add more</Link>&nbsp;
                    <button className="waves-effect waves-light darken-4 blue btn " onClick={() => { this.handleClick("BEVERAGES") }}>Add Beverges</button>&nbsp;
                    {this.props.orders.length > 0 ?
                            <Link className="waves-effect waves-light btn purple darken-4  " to="/checkout">Check Out</Link> : ""}

                    </div>

                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        items: state.addedItems,
        orders: state.orders,
        total: state.total
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        removeItem: (id) => { dispatch(removeItem(id)) },
        addQuantity: (id) => { dispatch(addQuantity(id)) },
        subtractQuantity: (id) => { dispatch(subtractQuantity(id)) },
        selectMainCategory: (id) => { dispatch(selectMainCategory(id)) }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Cart)